import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import GlobalSearch from 'flarum/forum/components/GlobalSearch';

/**
 * Casella di ricerca dell'header come quella del forum phpBB (search-box del tema runeaudio): campo "Search…",
 * bottone azzurro e link "Advanced search". Invio o il bottone portano ai risultati nella lista topic
 * (/all?q=…); "Advanced search" apre la finestra di ricerca di Flarum (discussioni, post, utenti, filtri).
 */
export default function extendSearchBox() {
  override(GlobalSearch.prototype, 'view', function () {
    if (this.sourceItems().isEmpty()) return m("div", null);
    const openModal = () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/common/components/SearchModal'), {
      searchState: this.searchState,
      sources: this.sourceItems().toArray()
    });
    const submit = e => {
      e.preventDefault();
      const q = (this.phpbbQuery ?? '').trim();
      if (q) m.route.set(app.route('index', {
        q
      }));
    };
    return m("div", {
      className: "PhpbbSearch",
      role: "search",
      "aria-label": app.translator.trans('core.forum.header.search_role_label', {}, true)
    }, m("form", {
      className: "PhpbbSearch-box",
      onsubmit: submit
    }, m("input", {
      className: "PhpbbSearch-input",
      type: "search",
      name: "keywords",
      placeholder: "Search\u2026",
      "aria-label": "Search for keywords",
      value: this.phpbbQuery ?? this.searchState.getValue() ?? '',
      oninput: e => this.phpbbQuery = e.target.value
    }), m("button", {
      className: "PhpbbSearch-button",
      type: "submit",
      title: "Search"
    }, m("span", {
      className: "sr-only"
    }, "Search"))), m("a", {
      className: "PhpbbSearch-advanced",
      href: "#",
      onclick: e => (e.preventDefault(), openModal())
    }, "Advanced search"));
  });
}